import { render, staticRenderFns } from "./TheTotallingTargetItem.vue?vue&type=template&id=4b5bead0&scoped=true&"
import script from "./TheTotallingTargetItem.vue?vue&type=script&lang=js&"
export * from "./TheTotallingTargetItem.vue?vue&type=script&lang=js&"
import style0 from "./TheTotallingTargetItem.vue?vue&type=style&index=0&id=4b5bead0&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5bead0",
  null
  
)

export default component.exports